import {
  startToolOperation,
  trackToolRejection,
  type ToolAnalyticsContext,
  type ToolPresetMask,
} from '@saas-pages/shared/public/runtime'
import type {
  CleanupError,
  CleanupOptions,
  CleanupResult,
} from '@/pages/ochistit-tekst/text-cleanup'

const BASE_CONTEXT = {
  app: 'txtify',
  domain: 'txtify.ru',
  route: '/ochistit-tekst',
  utility: 'text-cleanup',
  processingMode: 'local',
} as const

export function cleanupPresetMask(options: CleanupOptions): ToolPresetMask {
  const mask =
    (options.normalizeSpaces ? 1 : 0)
    | (options.removeEmptyLines ? 2 : 0)
    | (options.joinWrappedLines ? 4 : 0)
    | (options.tabsToSpaces ? 8 : 0)
    | (options.trimLines ? 16 : 0)

  return mask as ToolPresetMask
}

function context(
  options: CleanupOptions,
  outcome?: 'changed' | 'unchanged',
): ToolAnalyticsContext {
  return {
    ...BASE_CONTEXT,
    presetMask: cleanupPresetMask(options),
    ...(outcome === undefined ? {} : { outcome }),
  }
}

export function reportCleanupSuccess(
  options: CleanupOptions,
  result: CleanupResult,
  durationMs: number,
): void {
  const operation = startToolOperation(
    context(options, result.changed ? 'changed' : 'unchanged'),
  )
  operation.success(durationMs)
}

export function reportCleanupRejection(
  options: CleanupOptions,
  _error: CleanupError,
): void {
  trackToolRejection(context(options), 'size_limit')
}
